import { OrganizationMessage } from '@banksalad/idl/web/apis/v1/organization';
import {
  GetComparableDepositRequest,
  GetComparableDepositResponse,
  RankDepositResponse,
} from '@banksalad/idl/web/apis/v1/productcuration';
import {
  AppliedDepositCondition,
  ComparableDeposit,
  Deposit,
  DepositInterestCondition,
} from '@banksalad/idl/web/apis/v1/productcuration/savings';

import { createInstance, RequestWithCookie } from '@/src/apis';
import { API_PATH } from '@/src/constants/api-path';

export interface DepositExtended extends Deposit {
  organization: OrganizationMessage;
}

export interface AppliedDepositConditionExtended extends AppliedDepositCondition {
  interestRateCondition: DepositInterestCondition;
}

export interface ComparableDepositExtended extends ComparableDeposit {
  deposit: DepositExtended;
  appliedCondition: AppliedDepositConditionExtended;
}

export interface GetComparableDepositResponseExtended extends GetComparableDepositResponse {
  result: ComparableDepositExtended;
}

export const getComparableDeposits = async (
  productGuid: string,
  params: GetComparableDepositRequest,
  req?: RequestWithCookie
) => {
  const { data } = await createInstance(req).get<GetComparableDepositResponseExtended>(
    API_PATH.GET_COMPARABLE_DEPOSIT(productGuid),
    {
      params,
    }
  );

  return data;
};

export const getRankDeposits = async (productGuid: string, req?: RequestWithCookie) => {
  const { data } = await createInstance(req).post<RankDepositResponse>(
    API_PATH.GET_RANK_DEPOSIT(productGuid)
  );

  return data;
};
